import React, { useEffect, useState } from "react";
import { OpClass, AttrClass } from "./../datas/OpClass";
import { FxUtil } from "./../datas/FxUtil";
import { FxButton2 } from "./FxButton";
import { FxFooter } from "./FxFooter";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";


/**
 * 
 * @param {object} props 
 * opId : 운용코드
 * inObj : 그리드 상세보기 
 * attrList : 화면을 구성할 항목으로 이 값이 존재하면 opId의 화면구성 정보를 무시하고 이 내용을 사용한다.
 * @returns 
 */
export const FxDataPopup = props => {

  const { opId, selectedData, selectedDataId, attrListClass } = props;
  const [listClass, setListClass] = React.useState(null);
  const [opClass, setOpClass] = React.useState(null);

  useEffect(() => {
    if (opId) {
      const op = OpClass.getOpClass(opId);
      if (op) {
        setOpClass(op);
      }
    }
  }, [opId]);


  useEffect(() => {

    if (FxUtil.isEmpty(opClass)) return;

    setListClass(opClass.getAttrListClass());


  }, [opClass]);

  return (
    <FxDataDetail attrListClass={listClass} selectedData={selectedData} selectedDataId={selectedDataId} />
  )
};

/**
 * 데이터 편집용
 * @param {attrListClass, selectedData, selectedDataId} props 
 * @returns 
 */
const FxDataDetail = props => {

  const { attrListClass, selectedData, selectedDataId } = props;
  const [children, setChildren] = React.useState([]);
  const [dataChildren, setDataChildren] = React.useState([]);
  const [button, setButton] = React.useState([]);
  const newDatas = { ...selectedData };

  async function getDetailData() {

    const uri = "vupEngRoute/engPath/detail" + '/' + selectedData.engRtId;

    try {
      const res = await FxmsData.GET(uri, null);
      let index = 0;
      for (let data of res.data) {
        data.id = index++;
      }
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      makeColumns(res.data);
  
    } catch (error) {
      console.log("error" + error);
      FxWindow.alert("조회중 오류가 발행되었습니다.", true);
    }
  }

  const onClick = (event) => {
    let attrClass = attrListClass.getAttrClass(event.target.id);
    console.log('*** FxDataEdit *** onClick', event.target.id, attrClass);
    if (attrClass) {
      attrClass.onClick(newDatas, selectedDataId);
    }
  }

  const makeColumns = (dataList) => {
    const tbody = [];
    let index = 0;

    if (dataList !== null) {
      for (const i of dataList) {

        const engRoutList = i.engRoute.split('|');
        let engRouts;

        if (engRoutList.length > 0) {

          for (let i = 0; i < engRoutList.length - 1; i++) {
            if (i === 0) engRouts = engRoutList[i];
            else {
              engRouts = engRouts + '<br><br>' + engRoutList[i];
            }
          }
          engRouts = engRouts + '<br><br>' + engRoutList[engRoutList.length - 1];
        }
        tbody.push(<>
          <tr key={'r_' + index++}>
            <td key={'r_' + index++}>{i.engRtId}</td>
            <td key={'r_' + index++}>{i.engName}</td>
            <td key={'r_' + index++}>{i.sourceCompanyName}</td>
            <td key={'r_' + index++}>{i.sourceFacName}</td>
            <td key={'r_' + index++} dangerouslySetInnerHTML={{ __html: engRouts }}></td>
            <td key={'r_' + index++}>{i.sinkCompanyName}</td>
            <td key={'r_' + index++}>{i.sinkFacName}</td>
          </tr></>);
      }
    } else {
      tbody.push(<><tr key={'r_' + index++}><td key={'r_' + index++} colspan="7"> 조회된 데이터가 없습니다.</td></tr></>);
    }

    setDataChildren([tbody]);
  }

  const makeHead = () => {
    const para = { onClick: onClick, selectedDataId: selectedDataId, selectedData: selectedData };
    const tbody = [];
    let index = 0;

    const width = attrListClass.getLabelWidth();
    if (width === undefined) width = "120px";

    for (const line of attrListClass.getInputList()) {
      const list = attrListClass.getInputList()[0];

      tbody.push(<>
      <tr key={index++}>
        <th key={index++} rowspan="2">{list[0].attr.attrUiTxt}</th>
        <th key={index++} rowspan="2">{list[1].attr.attrUiTxt}</th>
        <th key={index++} colspan="2">{list[2].attr.attrUiTxt}</th>
        <th key={index++} rowspan="2">{list[3].attr.attrUiTxt}</th>
        <th key={index++} colspan="2">{list[4].attr.attrUiTxt}</th>
      </tr>
      <tr key={index++}>
          <th key={index++}>{list[5].attr.attrUiTxt}</th>
          <th key={index++}>{list[6].attr.attrUiTxt}</th>
          <th key={index++}>{list[7].attr.attrUiTxt}</th>
          <th key={index++}>{list[8].attr.attrUiTxt}</th>
      </tr></>
      )
    }
    const btns = [];
    for (const attrClass of attrListClass.getButtonList()) {
      btns.push(<FxButton2 attrClass={attrClass} para={para} />);
    }
    setChildren([tbody]);

    setButton(btns);
  }



  useEffect(() => {
    if (FxUtil.isEmpty(attrListClass)) return;
    makeHead();
    getDetailData();

  }, [attrListClass, selectedData]);

  return (
    <div className="FxDataPopup">
      <table key={'Table'} className="Table">
        {children}
        {dataChildren}
      </table>
      <div key={'ButtonBox'} className="ButtonBox">
        {button}
      </div>

      <FxFooter />
    </div>

  )
};